<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav minColor">产品</div></div>
                <div class="title">数据库工具</div>
                <div class="minTitle minColor">是一款通用、迅速、稳定和全面的数据库管理专用工具，专为简化数据库的管理及数据管理成本而设计，可以让用户通过统一的桌面视图管理成千上万的异构数据库实例，具有图形界面直观，功能便捷的特点 。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       <picture>
            <source srcset="@/assets/images/gj1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/gj1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">产品特点</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/gj2.png" />
                            <div class="lb">
                                纯java编写
                            </div>
                        </div>
                        <div class="minTitle2">
                            支持JDK1.8及以上版本 <br/>
                            测试过Windows\Linux\Mac OS <br/>
                            测试过X86和ARM芯片 
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/gj3.png" />
                            <div class="lb">
                                多视图
                            </div>
                        </div>
                        <div class="minTitle2">
                            标准视图 - 适合普通数据库用户<br/>
                            高级视图 - 适合管理员数据库用户
                        </div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/gj4.png" />
                            <div class="lb">
                                通用功能
                            </div>
                        </div>
                        <div class="minTitle2">
                            SQL查询器<br/>
                            管理对象树<br/>
                            数据库监控
                        </div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/gj5.png" />
                            <div class="lb">
                                独有功能
                            </div>
                        </div>
                        <div class="minTitle2">
                            快捷命令器<br/>
                            数据库任务<br/>
                            数据库宝典
                        </div>
                    </div>
                </div>
            </div>
       </div>
       <div class="botton pc_button">
            <div class="content">
                <div class="leftImg">
                    <img src="@/assets/images/gj6.png" />
                </div>
                <div class="rightCon">
                    <div class="title1 mt20 tc pb20">应用场景</div>
                    <div class="tab" :class="tab == 1? 'active': ''" @click="tab = 1">静态脱敏</div>
                    <div class="tab" :class="tab == 2? 'active': ''" @click="tab = 2">数据库安全操作</div>
                    <div class="tab" :class="tab == 3? 'active': ''" @click="tab = 3">自动化发布</div>
                    <div class="tab" :class="tab == 4? 'active': ''" @click="tab = 4">数据库自动巡检</div>
                    <div class="tabM" v-show="tab == 1">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj7.png" />
                            <div class="tabTitle yellow">痛点</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    1）源于监管压力-《网络安全法》、《个人信息安全规范》、《网络安全等级保护条例》等保2.0,等国家安全法规逐步出台，对用户的信息安全和数据安全的建立完善使用规范要求。<br/>
                                    2）开发人员不定时需要从数据中心拿测试数据，且时效要求高，使用数据频率高<br/>
                                    3）使用脚本脱敏数据质量与数据的脱敏效果无法同时满足
                                </div>
                            </div>
                        </div>
                        <div class="tabCon mt10" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">解决方案</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    直接连接生产与开发测试环境，提供安全可靠高质量的数据流通通道优势：<br/>
                                    日常使用与运维简单<br/>
                                    完全释放劳动力

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabM" v-show="tab == 2">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj7.png" />
                            <div class="tabTitle yellow">痛点</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    1）大多数用户都是通过登录堡垒机，在应用发布服务器上通过Plsql developer 、Navicat等数据库管理 工具连接数据库，这种方式仍然存在数据泄漏的风险，Plsql developer等工具可以查询生产库数据也可以 将数据导出来；<br/>
                                    2）操作数据库过程中无法对高危命令SQL、跨权限查询进行有效拦截，仅能依赖事后的审计报告核查<br/>
                                    3）操作员仅通过数据库账号操作数据库，无法实现对针对用户级别的细粒度权限控制
                                </div>
                            </div>
                        </div>
                        <div class="tabCon mt10" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">解决方案</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    1）引入管控平台，对用户进行细粒度权限管理，<br/>
                                    2）摆脱对客户端管理工具的依赖，实现精细化管控
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabM" v-show="tab == 3">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj7.png" />
                            <div class="tabTitle yellow">痛点</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    1）工作效率低<br/>
                                    2）误操作风险高<br/>
                                    3）人工成本高<br/>
                                    4）维护难度高
                                </div>
                            </div>
                        </div>
                        <div class="tabCon mt10" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">解决方案</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    1）统一环境配置，标准化部署，降低维护难度。<br/>
                                    2）批量操作，提升工作效率和运维相应速度。<br/>
                                    3）减少人工操作，提升运维效率，降低人工成本。<br/>
                                    4）平台化维护，避免过多人工干预，降低人工误操作风险

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabM" v-show="tab == 4">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj7.png" />
                            <div class="tabTitle yellow">痛点</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    1）异构数据库、同构数据的不同版本，造成经验不能通用，大大加大了运维监控的难度和工作量<br/>
                                    2）RAC、DataGuard等等企业组件加大了监管的难度<br/>
                                    3）人工填写的出错率不可避免、人工巡检的频繁度总是不足<br/>
                                    4）新的巡检目标难以完成
                                </div>
                            </div>
                        </div>
                        <div class="tabCon mt10" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">解决方案</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    1）自带多种数据库，多个版本标准巡检版本，同时支持自定义SQL巡检<br/>
                                    2）巡检方案可资产化—不依赖于个人经验、可定时执行、可动化生成报告
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
       <div class="mb_button">
        <div class="content">
            <div class="title1 tc">应用场景</div>
        </div>
        <div class="botton-swiper">
            <el-carousel arrow="never" ref="carousel" :autoplay="false">
                <el-carousel-item>
                    <div class="content">
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj7.png" />
                                    <p>痛点</p>
                                </div>
                                <div class="p">
                                    1）源于监管压力-《网络安全法》、《个人信息安全规范》、《网络安全等级保护条例》等保2.0,等国家安全法规逐步出台，对用户的信息安全和数据安全的建立完善使用规范要求。<br/>
                                    2）开发人员不定时需要从数据中心拿测试数据，且时效要求高，使用数据频率高<br/>
                                    3）使用脚本脱敏数据质量与数据的脱敏效果无法同时满足
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj8.png" />
                                    <p>解决方案</p>
                                </div>
                                <div class="p">
                                    直接连接生产与开发测试环境，提供安全可靠高质量的数据流通通道优势：<br/>
                                    日常使用与运维简单<br/>
                                    完全释放劳动力
                                </div>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="content">
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj7.png" />
                                    <p>痛点</p>
                                </div>
                                <div class="p">
                                    1）大多数用户都是通过登录堡垒机，在应用发布服务器上通过Plsql developer 、Navicat等数据库管理 工具连接数据库，这种方式仍然存在数据泄漏的风险，Plsql developer等工具可以查询生产库数据也可以 将数据导出来；<br/>
                                    2）操作数据库过程中无法对高危命令SQL、跨权限查询进行有效拦截，仅能依赖事后的审计报告核查<br/>
                                    3）操作员仅通过数据库账号操作数据库，无法实现对针对用户级别的细粒度权限控制
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj8.png" />
                                    <p>解决方案</p>
                                </div>
                                <div class="p">
                                    1）引入管控平台，对用户进行细粒度权限管理，<br/>
                                    2）摆脱对客户端管理工具的依赖，实现精细化管控
                                </div>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="content">
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj7.png" />
                                    <p>痛点</p>
                                </div>
                                <div class="p">
                                    1）工作效率低<br/>
                                    2）误操作风险高<br/>
                                    3）人工成本高<br/>
                                    4）维护难度高
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj8.png" />
                                    <p>解决方案</p>
                                </div>
                                <div class="p">
                                    1）统一环境配置，标准化部署，降低维护难度。<br/>
                                    2）批量操作，提升工作效率和运维相应速度。<br/>
                                    3）减少人工操作，提升运维效率，降低人工成本。<br/>
                                    4）平台化维护，避免过多人工干预，降低人工误操作风险
                                </div>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="content">
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj7.png" />
                                    <p>痛点</p>
                                </div>
                                <div class="p">
                                    1）异构数据库、同构数据的不同版本，造成经验不能通用，大大加大了运维监控的难度和工作量<br/>
                                    2）RAC、DataGuard等等企业组件加大了监管的难度<br/>
                                    3）人工填写的出错率不可避免、人工巡检的频繁度总是不足<br/>
                                    4）新的巡检目标难以完成
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <div class="tit">静态脱敏</div>
                            <div class="con">
                                <div class="t">
                                    <img class="titleImg" src="@/assets/images/gj8.png" />
                                    <p>解决方案</p>
                                </div>
                                <div class="p">
                                    1）自带多种数据库，多个版本标准巡检版本，同时支持自定义SQL巡检<br/>
                                    2）巡检方案可资产化—不依赖于个人经验、可定时执行、可动化生成报告
                                </div>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        
       </div>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">产品架构图</div>
                <div class="tc mt20">
                    <img class="jgtImg" src="@/assets/images/gj9.png" />
                </div>
            </div>
       </div>
    </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui'
    export default {
        components: {
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem
        },
        data() {
            return {
                tab: 1
            }
        },
        methods: {
            loadFlashImg() {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
                var that = this
                window.onresize = () => {
                    return (() => {
                        that.windowWidth = that.$refs.index.offsetWidth //获取屏幕宽度
                    })()
                }
            },
            startAuto() {
                var that = this
                if(that.autoplay == false){
                    that.autoplay = true;
                }
            },
            stopAuto() {
                var that = this
                if(that.autoplay == true){
                    that.autoplay = false;
                }
            },
            slideBanner1() {
                var that = this
                var box = document.querySelector('.botton-swiper .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel.prev();
                        return;
                    }
                });
            },
        },
        watch: {
            windowWidth (val) {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
            }
        },
        mounted() {
            this.slideBanner1()
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .jgtImg {
            height: 427px;
            width: 928px;
        }
        .lxwm {
            padding: 30px 0;
            .items {
                display: flex;
                flex-wrap: wrap;

                .item2 {
                    margin-top: 20px;
                    width: 19.49%;
                    background-color: #ffffff;
                    margin-right: 2%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        margin-top: 10px;
                        line-height: 20px;
                    }
                }
                .item3 {
                    margin-right: 0;
                }
            }
        }
        .botton {
            min-height: 480px;
            background: url(../../assets/images/rpa16.png) no-repeat;
            background-size: cover;
            
            .leftImg {
                float: left;
                width: 45%;
                img {
                    width: 530px;
                    height: 350px;
                    margin-top: 70px;
                }

            }
            .rightCon {
                float: right;
                width: 53%;
                .title1 {
                    color: #ffffff;
                }
                .tab {
                    display: inline-block;
                    color: #ffffff;
                    font-size: 14px;
                    border: 1px solid #ffffff;
                    margin-right: 10px;
                    padding: 2px 10px;
                    border-radius: 20px;
                    cursor: pointer;
                }
                .tab.active {
                    background: -webkit-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -o-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -moz-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: linear-gradient(to right,#6BDEFF, #3C91FF);
                }
                .tabM {
                    margin-top: 15px;
                    border: 2px solid #2b4b87;
                    padding: 15px;
                    .tabCon {
                        background-color: #161644;
                        padding: 15px 10px 15px 10px ;
                        .titleImg {
                            width: 20px;
                            height: 20px;
                            margin-right: 7px;
                        }
                        
                        .tabTitle {
                            color: #36B9FE;
                            font-size: 14px;
                            line-height: 23px;
                            vertical-align: bottom;
                            display: inline-block;
                        }
                        .yellow {
                            color: #FADB00;
                        }
                        .tabConItems {
                            padding: 10px 0 0 27px;
                            .minTitle2 {
                                color: #ffffff;
                                line-height: 20px;
                            }
                            .item {
                                display: inline-block;
                                color: #ffffff;
                                background: url(../../assets/images/rpa17.png) no-repeat;
                                background-size: auto 80%;
                                background-position-y: center;
                                text-indent: 17px;
                                width: 24%;
                                margin-bottom: 5px;
                            }
                        }
                    }
                }
                    

            }
        }
        .mb_button {
            display: none;
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
    .lxwm .items {
        justify-content: space-between;
        .item2 {
            width: 20%;
            margin-right: 0;
        }
    } 
    .botton {
        min-height: 580px;
        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .leftImg {
                img {
                    width: 100%;
                    height: auto;
                    margin-top: 0;
                }
            }
            .rightCon {
                width: auto;
                flex: 1;
                margin-left: 80px;
                .tab {
                    margin-bottom: 15px;
                }
                .tabM {
                    margin-top: 0;
                }
                .tabM .tabCon .tabConItems {
                    padding: 10px 0 0 0;
                }
            }
        }
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        .title {
          font-size: 20px;
        }
        .minTitle {
          width: 40%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .lxwm .items {
        flex-wrap: wrap;
        .item2 {
            width: 45%;
        }
    } 
    .botton .content {
        .leftImg {
            width: 40%;
        }
        .rightCon {
            margin-left: 20px;
        }
    }
    .jgtImg {
        width: 100%;
        height: auto;
    }
    .mb_button {
        display: block;
        background: #f6f8ff;
        overflow: hidden;
        .title1 {
            margin-top: 0;
            margin-bottom: 20px;
        }

        .botton-swiper {
            padding: 30px 0;
            min-height: 360px;
            background: url(../../assets/images/rpa16.png) no-repeat;
            background-size: cover;
            /deep/ .el-carousel--horizontal {
                height: 450px;
            }
            /deep/ .el-carousel__container {
                height: 100%;
            }
            .block {
                margin-bottom: 25px;
                padding: 0 10px;
                
                .tit {
                    color: #ffffff;
                    font-size: 18px;
                    text-align: center;
                    margin-bottom: 15px;
                }
                .con {
                    .t {
                        display: flex;
                        align-items: center;
                        color: #ffffff;
                        margin-bottom: 15px;
                        img {
                            width: 22px;
                            height: 22px;
                            margin-right: 5px;
                        }
                    }
                    .p {
                        color: #ffffff;
                    }
                }
            }
            .block:last-of-type {
                margin-bottom: 0;
            }
        }
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
        .lxwm {
            .content .title1 {
                margin: 0;
                margin-bottom: 20px;
            }
            .items {
                .item2 {
                    width: 100%;
                    margin-bottom: 20px;
                    margin-top: 0;
                    .tit {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    img {
                        height: 18px;
                    }
                    .lb {
                        line-height: normal;
                    }
                    .minTitle2 {
                        font-size: 14px;
                    }
                    
                }
                .item2:last-of-type {
                    margin-bottom: 0;
                }
            } 
        }
        .pc_button {
            display: none;
        }
        .mb_button {
            display: block;
        }
    }
}
</style>